import "./styles/index.scss";
import axios from 'axios';
import { SortReviews } from "./sortReviews/sortReviews"
import { Helpful } from "./helpful/helpful";
import { PageNav } from "./pageNav/pageNav";
import { Carousel } from "./carousel/carousel";
import { Utils } from "../utils/utils";
import { rrWidget } from "../rr-widget";
import config from '../config/environmentConfig';
import { brandConfig } from "../brandConfig";

export class ReadPanel extends rrWidget {
    listenerAdded: boolean
    allMediaData: Array<any>
    totalMediaCount: number
    domSelector: object
    tabFlag: String
    reviewListcounter = 1;
    questionListtester =100;
    handleListenerQuestionTab:any;
    handleListenerReviewTab:any;
    initReviewCarouselHandleListener;
    constructor() {
        super();
        this.BILibLoaded = this.BILibLoaded;
        this.brand = this.brand;
        this.locale = this.locale;
        this.filterby = this.filterby;
        this.sortby = this.sortby;
        this.langaugeby =this.langaugeby;
        this.filterByImg = this.filterByImg
        this.listenerAdded = false;
        this.allMediaData = [];
        this.totalMediaCount = 0;
        this.domSelector = {
            'dataAdded': 'data-added',
            'entityId': 'entityId',
            'uniqueId': 'uniqueId'
        };
        this.tabFlag = 'review';
    }

    hideInitialTabContent():void {
        var i, tabcontent, reviewTabBtn;

        tabcontent = document.getElementsByClassName("kr-tabContent");
        reviewTabBtn = document.querySelector('.review-tab-btn');
        for(i =0 ;i<tabcontent.length;i++){
            if(tabcontent[i].id !== 'kr-review') {
                tabcontent[i].classList.add('kr-hide');
            }
            else reviewTabBtn.classList.add('active');
        }
    }
    showTabContent(event,tabName): void{
        const tabEl = document.querySelector(`#${tabName}`) as HTMLElement;
        tabEl.classList.remove('kr-hide')
        // tabEl.classList.add('active');
    }
    hideTabContent(event,tabName): void{
        const tabEl = document.querySelector(`#${tabName}`) as HTMLElement;
        tabEl.classList.add('kr-hide');
        // tabEl.classList.remove('active');
    }

    addReviewTabListner(initReviewCarouselEvent): void {
        this.hideInitialTabContent();
        this.askQuestionBtnListener();
        const $reviewtab = document.querySelector('.review-tab-btn'),
              $questionTab = document.querySelector('.question-tab-btn');
        if($reviewtab) {
            ReadPanel.prototype.handleListenerReviewTab = (event) =>{
                event.preventDefault();
                $reviewtab.classList.add('active');
                $questionTab.classList.remove('active');
                this.hideTabContent(event,'kr-question')
                this.showTabContent(event,'kr-review');
                document.dispatchEvent(initReviewCarouselEvent);
            }
            $reviewtab.removeEventListener('click', ReadPanel.prototype.handleListenerReviewTab);
            $reviewtab.addEventListener('click', ReadPanel.prototype.handleListenerReviewTab);
        }
    }
    addQuestionsTabListner(): void {
        this.tabFlag = 'question';
        const $questionTab = document.querySelector('.question-tab-btn'),
              $reviewtab = document.querySelector('.review-tab-btn');
        // const element = document.querySelector('[data-readpanel-template]') as HTMLElement;
        if($questionTab) {
            ReadPanel.prototype.handleListenerQuestionTab = (event) => {
                event.preventDefault();
                // const readQuestionClass = await import("../question/questionReadPanel/questionReadPanel");
                // const readQuestionClassObj = new readQuestionClass.QuestionReadPanel();
                // readQuestionClassObj.getQuestionReadPanelTemplate(element, this.brand, this.locale, this.sortby, this.quesPgNum, this.size, false);
                $questionTab.classList.add('active');
                $reviewtab.classList.remove('active');
                this.hideTabContent(event,'kr-review');
                this.showTabContent(event,'kr-question');
                let initQuestionCarouselEvent = new CustomEvent("initQuestionCarouselEvent");
                document.dispatchEvent(initQuestionCarouselEvent);
            }
            $questionTab.removeEventListener('click', ReadPanel.prototype.handleListenerQuestionTab)
            $questionTab.addEventListener('click', ReadPanel.prototype.handleListenerQuestionTab)
        }
    }

    askQuestionBtnListener(): void {
        const $writeQuesLink = document.querySelector('.ask-a-questionLink'),
              $questionTab = document.querySelector('.question-tab-btn') as HTMLElement
        if($writeQuesLink){
            $writeQuesLink.addEventListener('click', async(event:any)=>{
                event.preventDefault();
                $questionTab.tabIndex = 0;
                $questionTab.click();
                const $askQuestion = document.querySelector('.ask-a-questionBtn') as HTMLElement;
                if ($askQuestion) {
                    $askQuestion.click();
                }
            })
        }
    }
    async getWidgetConfiguration(brand:string, locale:string, apikey:string) {
        try {
            await axios({
                method: 'get',
                url: config.baseUrl + '/widget/getWidgetConfig',
                params: {
                    brand,
                    locale,
                    apikey: apikey
                },
                headers: {
                    contentType: 'application/json'
                },
            }).then(async (response) => {
                window.rrWidgetConfig = response.data.widgetConfig;
            })
        } catch (error) {
            window.rrWidgetConfig.error = error;
            console.error(error);
        }
    }

    async getQuestionSummery(brand:string, locale:string, apikey:string, filterFlag:boolean, paginationFlag:boolean) {
        let responseData:any;
        try {
            await axios({
                method: 'get',
                url: config.baseUrl + '/widget/getQuestionSummery',
                params: {
                    brand,
                    locale,
                    apikey: apikey,
                    filterFlag,
                    paginationFlag,
                    widgetConfig: window.rrWidgetConfig
                },
                headers: {
                    contentType: 'application/json'
                },
            }).then(async (response) => {
                window.rrWidgetConfig = response.data.widgetConfig;
                responseData = response;
            })
        } catch (error) {
            window.rrWidgetConfig.error = error;
            console.error(error);
        }
        return responseData;
    }

    getReadPanelTemplate(element: HTMLElement, brand: string, locale: string, rating: string, sortedBy: string,imageFilter:boolean, pageNumber: number, size: number, langaugeby:string, filterFlag?: boolean, paginationFlag?: boolean,): object {
        // prevent duplicate event dispatch for the same element
        if(!langaugeby && window.rrWidgetConfig.languages)
        {
            const allLangsData = window.rrWidgetConfig.languages.map(item => {return item.value})
            langaugeby = allLangsData.join(',');
        }
        if (filterFlag != true && (((!filterFlag && paginationFlag == undefined) || !(!filterFlag && paginationFlag)) && (filterFlag !== undefined && paginationFlag !== undefined))) {
            if (element.getAttribute(this.domSelector['dataAdded'])) return;
            element.setAttribute(this.domSelector['dataAdded'], 'true');
        }
        try {
            Utils.setDataDirAttribute(locale, element);
            let self = this,
            carouselObj = new Carousel();
            let entityId = element.dataset[self.domSelector['entityId']] ? element.dataset[self.domSelector['entityId']] : element.dataset[self.domSelector['uniqueId']];
            let widgetConfig = window.rrWidgetConfig;
            document.addEventListener("keydown", (ev) => {
                if (ev.key === "Escape") {
                    //checking for report form if it is open close on escape
                    let popup = document.querySelector('.reportForm') as HTMLElement,
                        btnId = popup.getAttribute('id'),
                        btnToFocus = document.getElementsByClassName(btnId);
                    
                    if(popup){
                        popup.classList.add('kr-hide');
                        (btnToFocus[0] as HTMLElement).focus()
                    }
                }
            });
            if (widgetConfig.isFeatureQuestions && !widgetConfig.isFeatureReviews) {
                this.getQuestionSummery(brand, locale, brandConfig.apikey, filterFlag, paginationFlag)
                .then((response) => {
                    let view = response.data && response.data.view ? response.data.view : '';
                    element.innerHTML += view;
                    self.setDataAttribute(element, response.data['entityName'], response.data['entityImageURL']);
                    self.addQuestionsTabListner();
                    self.questionPanel(element);
                    let initReviewCarouselEvent = new CustomEvent("initReviewCarouselEvent");
                    document.dispatchEvent(initReviewCarouselEvent);
                    if (window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrRender) {
                        window.ratingReview.events.rrRender(element);
                    }
                    const renderEvent = new Event('rrRender');
                    document.dispatchEvent(renderEvent); 
                });
            } else {
                axios({
                    method: 'get',
                    url: config.baseUrl + '/widget/readReview',
                    params: {
                        brand,
                        locale,
                        entityId,
                        filterFlag,
                        paginationFlag,
                        rating,
                        pageNumber,
                        apikey: brandConfig.apikey,
                        pageSize: size || self.size,
                        sortBy: sortedBy || self.sortby,
                        filterByImg: imageFilter || self.filterByImg,
                        userAgent: Utils.getDeviceUserAgent()['userAgent'],
                        currentPage: window.location.href,
                        widgetConfig: widgetConfig
                    },
                    headers: {
                        contentType: 'application/json',
                        languages: langaugeby,
                    },
                }).then(async (response) => {
                    let reviews = response.data.reviews,
                        filteredReviewCount = response.data.filteredReviewCount,
                        allMedia = response.data['mediaData'],
                        userAgent = response.data.userAgent,
                        filterFlag = response.data.filterFlag,
                        totalMediaCount = (response.data.hasOwnProperty('totalMediaCount') && response.data['totalMediaCount'] > 0) ? response.data['totalMediaCount'] : 0,
                        view = response.data && response.data.view ? response.data.view : '';
                    if (response.data.error) {
                        reviews = [],
                            allMedia = [],
                            filteredReviewCount = 0,
                            userAgent = Utils.getDeviceUserAgent()['userAgent'],
                            filterFlag = false,
                            totalMediaCount = 0,
                            await axios({
                                method: 'get',
                                url: config.baseUrl + '/widget/readReview/errortemplate',
                                params: {
                                    brand,
                                    locale,
                                    widgetConfig: widgetConfig
                                },
                                headers: {
                                    contentType: 'application/json'
                                }
                            }).then((response) => {
                                view = response.data
                            })
                    }
                    if (!(filterFlag || paginationFlag)) {
                        element.innerHTML += view;
                        let initReviewCarouselEvent = new CustomEvent("initReviewCarouselEvent");
                        self.updatePageNav(self, filteredReviewCount);
                        self.setDataAttribute(element, response.data['entityName'], response.data['entityImageURL']);
                        if (!self.listenerAdded) {
                            self.scrollToReviewsOnBarClick();
                            self.addListenerForWritePanel();
                            self.skipToReviews();
                            if (totalMediaCount) {
                                ReadPanel.prototype.allMediaData = allMedia;
                                ReadPanel.prototype.totalMediaCount = totalMediaCount;
                                ReadPanel.prototype.initReviewCarouselHandleListener = () => {
                                    //carouselObj.initateAllCarousel(allMedia, totalMediaCount);
                                }
                                document.removeEventListener('initReviewCarouselEvent', ReadPanel.prototype.initReviewCarouselHandleListener);
                                document.addEventListener('initReviewCarouselEvent', ReadPanel.prototype.initReviewCarouselHandleListener);
                                //carouselObj.initateAllCarousel(allMedia, totalMediaCount);
                                carouselObj.openMediaOverlay();
                                carouselObj.closeMediaOverlay();
                            }
    
                        }
                        
                        self.addReviewTabListner(initReviewCarouselEvent);
                        if (widgetConfig.isFeatureQuestions) {
                            self.addQuestionsTabListner();
                            self.questionPanel(element);   
                        }
                        document.dispatchEvent(initReviewCarouselEvent);
                        if (window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrRender) {
                            window.ratingReview.events.rrRender(element);
                        }
                        const renderEvent = new Event('rrRender');
                        document.dispatchEvent(renderEvent);
                    } else {
                        const reviewSection = document.querySelector(".kr-reviews-container");
                        reviewSection.innerHTML = view;
                        const $pageSelector = document.querySelector(".kr-pagination-nav");
                        if (filterFlag) self.pageNumber = 0
                        if (reviews && reviews.length > 0 && filteredReviewCount > self.size) {
                            $pageSelector && $pageSelector.classList.remove('isInactive');
                            if (!paginationFlag || rrWidget.prototype.pageNumber == 0) {
                                let totalPages = Math.ceil(filteredReviewCount / self.size);
                                PageNav.prototype.pagingTextUpdate(totalPages, self.pageNumber, self.size, filteredReviewCount)
                                let $countHeaderSelector = document.querySelector('.kr-review-count-header span');
                                if ($countHeaderSelector) {
                                    (!filteredReviewCount && filteredReviewCount <= 0) ? $countHeaderSelector.parentElement.classList.add('kr-hide') : $countHeaderSelector.parentElement.classList.add('show');
                                    $countHeaderSelector.innerHTML = filteredReviewCount;
                                }
                            }
                        } else if ($pageSelector) {
                            $pageSelector.classList.add('isInactive');
                        }
                        if (!paginationFlag) {
                            self.updatePageNav(self, filteredReviewCount);
                        }
                    }
                    carouselObj.initSwiper(allMedia, totalMediaCount);
                    self.removeCountHeader(filteredReviewCount);
                    //language-by
                    self.languageByOnChange();
                    // sort-by
                    self.sortByOnChange(); //reviews['data']['filteredReviewCount']
                    // filter-onChange
                    self.filterOnChange();
                    let HelpfulObj = new Helpful();
                    HelpfulObj.addReviewAsHelpful();
                    HelpfulObj.addReviewAsReported();
                    HelpfulObj.updateReviewCommentMessage();
                    HelpfulObj.onSubmitReport();
                    HelpfulObj.onReasonChange();
                    if (userAgent !== 'desktop') HelpfulObj.shareReviews();
                    else HelpfulObj.openDeskShareReview();
    
            // const tabEl = document.querySelector(`#kr-question`) as HTMLElement;
            // tabEl.classList.add('kr-hide');
                    return response.data;
                }).then((reviewsData) => {
                    let self = this;
                    if (!self.BILibLoaded) {
                        carouselObj.blueImpLoad();
                    }
                    let allReviews = reviewsData['reviews'],
                        intervalId = null;
                    let varCounter = 0;
                    let varInitCarousel = () => {
                        if (varCounter <= 5) {
                            let comments = document.querySelectorAll('.kr-comments');
                            if (comments.length) {
                                carouselObj.initateAllCarousel(allReviews, 0);
                                varCounter += 5;
                            }
                            varCounter++;
                        } else {
                            clearInterval(intervalId);
                            intervalId = null;
                        }
                    }
                    if(!intervalId){
                        intervalId = setInterval(varInitCarousel, 1000);
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
        return;
    }

    removeCountHeader(filterReviewCount: number): void {
        let $countHeaderSelector = document.querySelector('.kr-review-count-header span');
        if ($countHeaderSelector) {
            if ((!filterReviewCount || filterReviewCount == 0)) {
                $countHeaderSelector.parentElement.classList.add('kr-hide');
                $countHeaderSelector.parentElement.classList.remove('show');
            } else {
                $countHeaderSelector.parentElement.classList.add('show');
                $countHeaderSelector.parentElement.classList.remove('kr-hide');
            }
            $countHeaderSelector.innerHTML = JSON.stringify(filterReviewCount);
        }
    }

    updatePageNav(t, filterReviewCount): void {
        let PageNavObj = new PageNav();
        let totalPages = Math.ceil(filterReviewCount / t.size);
        let $pageNavList = document.querySelector(".kr-pagination-nav ul");
        let pageNo;
        let getPageNumberValue = Utils.getPageNumber();
        if (getPageNumberValue && getPageNumberValue>0) {
            pageNo = getPageNumberValue -1
        } else {
            pageNo = t.pageNumber >= 0 ? t.pageNumber : ReadPanel.prototype.pageNumber;
        }
        if ($pageNavList) {
            $pageNavList.innerHTML = PageNavObj.getPageNav(totalPages, pageNo);
        }
        PageNavObj.addPaginationListener(totalPages, pageNo, filterReviewCount);
    }

    languageByOnChange(): void {
        let dropdownlanguageSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector(".kr-language-by select");
        
        if (dropdownlanguageSelect) {
            let languageByReviewsObj = new SortReviews(dropdownlanguageSelect);
            let sortCb = async () => {
                this.pageNumber = 0;
                this.langaugeby = languageByReviewsObj.getSortReviews();
                rrWidget.prototype.langaugeby = this.langaugeby;
                if (rrWidget.prototype.filterby) {
                    this.filterby = rrWidget.prototype.filterby;
                }
                if (rrWidget.prototype.filterByImg) {
                    this.filterByImg = rrWidget.prototype.filterByImg;
                }
                if (rrWidget.prototype.sortby) {
                    this.sortby = rrWidget.prototype.sortby;
                }
                let selectIndex = dropdownlanguageSelect.options.selectedIndex;
                if(selectIndex === 0) {
                    const allLangs = window.rrWidgetConfig.languages.map(item => {return item.value})
                    this.langaugeby = allLangs.join(',');
                    rrWidget.prototype.langaugeby = this.langaugeby;
                }
                document.querySelector(".kr-languageBySelect option[selected]").removeAttribute('selected');
                dropdownlanguageSelect.options[selectIndex].setAttribute('selected', 'true');
                await this.renderElementOnceInViewPort(this.brand, this.locale, this.filterby, this.sortby, this.langaugeby, this.filterByImg, this.pageNumber, this.size, true, false);
                // this.updatePageNav(this, filterReviewCount);
            };
            dropdownlanguageSelect.onchange = sortCb;
        }
    }

    sortByOnChange(): void {
        let dropdownSortSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector(".kr-sort-by select");
        if (dropdownSortSelect) {
            let sortReviewsObj = new SortReviews(dropdownSortSelect);
            let sortCb = async () => {
                this.pageNumber = 0;
                this.sortby = sortReviewsObj.getSortReviews();
                rrWidget.prototype.sortby = this.sortby;
                if (rrWidget.prototype.filterby) {
                    this.filterby = rrWidget.prototype.filterby;
                }
                if (rrWidget.prototype.filterByImg) {
                    this.filterByImg = rrWidget.prototype.filterByImg;
                }
                if (rrWidget.prototype.langaugeby) {
                    this.langaugeby = rrWidget.prototype.langaugeby;
                }
                let selectIndex = dropdownSortSelect.options.selectedIndex;
                document.querySelector(".kr-sortBySelect option[selected]").removeAttribute('selected');
                dropdownSortSelect.options[selectIndex].setAttribute('selected', 'true');
                await this.renderElementOnceInViewPort(this.brand, this.locale, this.filterby, this.sortby, this.langaugeby, this.filterByImg, this.pageNumber, this.size, true, false);
                // this.updatePageNav(this, filterReviewCount);
            };
            dropdownSortSelect.onchange = sortCb;
        }
    }

    filterOnChange(): void {
        let filterDropDowns = document.querySelectorAll('.kr-filters select');
        for(let i=0;i<filterDropDowns.length; i++){
            let filterSelect: HTMLSelectElement = <HTMLSelectElement>filterDropDowns[i];
            if(filterSelect){
                let filteredSelectValueObj = new SortReviews(filterSelect);
                let filterChange =  async (event) => {
                    let parentClass = 'filter-by';
                    this.pageNumber = 0;
                    let selectIndex = event.detail && event.detail.selectIndex ? event.detail.selectIndex: undefined;
                    if(rrWidget.prototype.sortby) this.sortby = rrWidget.prototype.sortby;
                    if(rrWidget.prototype.filterby) this.filterby = rrWidget.prototype.filterby;
                    if(rrWidget.prototype.langaugeby) this.langaugeby = rrWidget.prototype.langaugeby;
                    if(rrWidget.prototype.filterByImg) this.filterByImg = rrWidget.prototype.filterByImg;
                    if(event.target.className === 'kr-filterBySelect'){
                        parentClass = 'filter-by';
                        this.filterby = await filteredSelectValueObj.getSortReviews(selectIndex);
                        rrWidget.prototype.filterby = this.filterby;
                    }else if(event.target.className === 'kr-filterByImages'){
                        parentClass = 'filter-by-images';
                        this.filterByImg = await filteredSelectValueObj.getSortReviews(selectIndex) !== '' ? true: false;
                        rrWidget.prototype.filterByImg = this.filterByImg;
                    }
                    document.querySelector(`.${event.target.className} option[selected]`).removeAttribute('selected');

                    let filterSelectFunction: HTMLSelectElement = <HTMLSelectElement>document.querySelector(`.${parentClass} select`);

                    if (!selectIndex || selectIndex === undefined) {
                        selectIndex = filterSelectFunction.options.selectedIndex;
                    }
                    filterSelectFunction.options[selectIndex].setAttribute('selected', 'true');
                    await this.renderElementOnceInViewPort(this.brand, this.locale, this.filterby, this.sortby, this.langaugeby, this.filterByImg, this.pageNumber, this.size, true);
                };
                filterSelect.onchange = filterChange;
            }
        }
    } 

    scrollToReviewsOnBarClick(): void {
        let self = this;
        document.querySelectorAll('.kr-ratingbar-col').forEach(item => {
            if (!self.listenerAdded) {
                item.addEventListener('click', async (event) => {
                    self.listenerAdded = true;
                    // @ts-ignore
                    let eventTitle: number = parseInt((event.target as HTMLElement).getAttribute('data-value'));
                    const filterBySelector = (document.querySelector('.kr-review-count-header') as HTMLElement);
                    if (filterBySelector) {
                        // filterBySelector.focus();
                        await self.scrollToReview(eventTitle);
                    }
                    rrWidget.prototype.filterby = 'rating ' + eventTitle;
                });
            }
        })
    }

    scrollToReview(eventVal: number): void {
        let reviewsSelector = document.querySelector(".kr-review-count-header"),
            readPanelReviewsSelector = document.querySelector(".kr-readpanel-reviews"),
            dropdownSortSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector(".filter-by select"),
            selectedIndex = dropdownSortSelect.options.selectedIndex,
            nextSelectionIndex;
        if (eventVal) {
            nextSelectionIndex = [5, 4, 3, 2, 1].indexOf(eventVal);
        } else {
            nextSelectionIndex = selectedIndex
        }
        dropdownSortSelect.options.selectedIndex = nextSelectionIndex + 1;
        const e = new CustomEvent("change", { detail: { 'selectIndex': nextSelectionIndex + 1 } });
        let filterIdentifier : HTMLElement = <HTMLElement>document.querySelector("#kr-filtered-rating");
        filterIdentifier.innerHTML = `${eventVal}`;
        let displayHtmlIndex: HTMLElement = <HTMLElement>document.querySelector('#kr-display-filtered-index');
        displayHtmlIndex.classList.remove('kr-hide');
        dropdownSortSelect.dispatchEvent(e);
        if (readPanelReviewsSelector) {
            readPanelReviewsSelector.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    // Render Element only when the data-readpanel-template is in view port
    renderElementOnceInViewPort(brand: string, locale: string, filterby: string, sortby: string, langaugeby: string, filterByImg: boolean, pageNumber: number, size: number, filterFlag?: boolean, paginationFlag?: boolean, elem?: HTMLElement): void {
        const element = elem ? elem : document.querySelector('[data-readpanel-template]') as HTMLElement;
        if (filterFlag || paginationFlag || Utils.isInViewport(element as HTMLElement)) {
            this.getReadPanelTemplate(element, brand, locale, filterby, sortby,filterByImg, pageNumber, size,langaugeby, filterFlag, paginationFlag);
        } else {
            document.addEventListener('scroll', () => {
                if (Utils.isInViewport(element as HTMLElement)) {
                    this.getReadPanelTemplate(element, brand, locale, filterby, sortby,filterByImg, pageNumber, size,langaugeby, filterFlag, paginationFlag);
                }
            });
        }
    }

    addListenerForWritePanel(): void {
        const $writeButton = document.querySelector('.write-review-btn');
        if ($writeButton) {
            $writeButton.addEventListener('click', async (event) => {
                event.preventDefault();
                const writeReviewClass = await import("../writeReview/writeReview");
                const writeReviewObj = new writeReviewClass.writeReview();
                writeReviewObj.getWriteReview(this.brand, this.locale, $writeButton);
                if(document.querySelector('.kr-loader-overlay'))
                    document.querySelector('.kr-loader-overlay').classList.remove('kr-hide');
            });
        }
    }

    observeReadPanel(readElement: HTMLElement, brand: string, locale: string, filterby: string, sortby: string, langaugeby:string, filterByImg: boolean, pageNumber: number, size: number, filterFlag?: boolean, paginationFlag?: boolean) {
        let self = this;
        let handleListener = (ev) => {
            event.preventDefault();
            let $readPanelSelector = ev.detail && ev.detail.selectorElement ? ev.detail.selectorElement : document.querySelector('[data-summary-template]') as HTMLElement;
            self.renderElementOnceInViewPort(brand, locale, filterby, sortby,langaugeby,filterByImg, pageNumber, size, filterFlag, paginationFlag, $readPanelSelector);
        }
        if (readElement) {
            readElement.removeEventListener('renderReadPanelEvent', handleListener);
            readElement.addEventListener('renderReadPanelEvent', handleListener);
            let readPanelEvent = new CustomEvent("renderReadPanelEvent", {
                detail: {
                    selectorElement: readElement
                }
            });
            readElement.dispatchEvent(readPanelEvent);
        }
    }

    setDataAttribute(element, entityName, imageUrl): void {
        if (!element.dataset.hasOwnProperty('entityName')) {
            element.setAttribute('data-entity-name', entityName);
        }
        if (!element.dataset.hasOwnProperty('entityImageUrl')) {
            element.setAttribute('data-entity-image-url', imageUrl);
        }
        return;
    }
    skipToReviews() {
        const $skipButton = document.querySelector('.kr-skip-to-content');
        if ($skipButton) {
            $skipButton.addEventListener('click', async (event) => {
                event.preventDefault();
                const $reviewHeading = (document.querySelector('.kr-review-count-header') as HTMLElement);
                $reviewHeading.focus();
            });
        }
    }
}